// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"203":"bb1f3d5b","266":"12ec8413","437":"12ec8413","679":"39860b74"}[chunkId] + ".chunk.css";
};